import React from "react";
import { UseLocalStorage } from "../UseLocalStorage";
const TodoContext = React.createContext();

function TodoProvider ({children}){
    const{
        item : todos,
        saveItem: saveTodos,
        loading,
        error,
    }=UseLocalStorage('TODOS_V1' , []);
    const [searchValue, setSearchValue]=React.useState('');
    const [openModal , setOpenModal] = React.useState(false);
    const completeTodos = todos.filter(todo=>!!todo.completed).length;
    const totalTodos = todos.length;

    const searchedTodos = todos.filter((todo)=>{
      const todoText = todo.text.toLowerCase();
      const searchText = searchValue.toLowerCase();
      return todoText.includes(searchText);
    });
  
    const addTodo = (text)=>{
      const clonTodos = [...todos];
      clonTodos.push({
        text,
        completed: false
      })
      saveTodos(clonTodos);
    }

    const todoComplete = (text)=>{
      const clonTodos = [...todos];
      const todoIndex = clonTodos.findIndex(
        (todo) => todo.text === text
      );
      clonTodos[todoIndex].completed = true;
      saveTodos(clonTodos); 
    };

    const todoDelete = (text) =>{
      const clonTodos = [...todos];
      const todoIndex = clonTodos.findIndex(
        (todo) => todo.text === text
      );
      clonTodos.splice(todoIndex,1);
      saveTodos(clonTodos); 
    }

    return(
        <TodoContext.Provider value={{
            loading,
            error, 
            completeTodos,
            searchValue,
            totalTodos,
            setSearchValue,
            searchedTodos,
            todoComplete,
            todoDelete,
            openModal,
            setOpenModal,
            addTodo,
        }}>
            {children}
        </TodoContext.Provider>
    )
}

export { TodoContext, TodoProvider };